import { supportIntersectionObserver } from '@packages/hooks/useIntersect';

/**
 * LazyLoading observer
 * TODO: Implement polyfill (https://github.com/w3c/IntersectionObserve)
 * @type {IntersectionObserver}
 */
export const intersectionObserver = supportIntersectionObserver()
    ? new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
              if (entry) {
                  const { target, isIntersecting } = entry;

                  if (isIntersecting) {
                      target.dispatchEvent(new Event('intersect'));
                      intersectionObserver!.unobserve(target);
                  }
              }
          });
      })
    : null;

/**
 * Create intersection event
 * @example
 * useEffect(() => {
 *     const unlisten = createIntersect(ref, () => {
 *         // Actions to take when element it's on
 *     });
 *
 *     return () => {
 *         // remove event & observer
 *         unlisten();
 *     }
 * })
 * @param ref
 * @param handler
 * @return {Function}
 */
export function createIntersect(ref, handler) {
    if (ref) {
        ref = ref.current || ref;
    }

    if (ref) {
        ref.addEventListener('intersect', handler);
        if (intersectionObserver) {
            intersectionObserver.observe(ref);
        } else {
            ref.dispatchEvent(new Event('intersect'));
        }
    }

    return () => {
        if (ref) {
            if (intersectionObserver) {
                intersectionObserver.unobserve(ref);
            }

            ref.removeEventListener('intersect', handler);
        }
    };
}
